export default class Nsc {
  constructor(token, userDetails, history) {
    if (userDetails) {
      this.userId = userDetails.userId;
      this.commonName = userDetails.commonName;
      this.market = userDetails.market;
      this.fullName = userDetails.fullName;
      this.userType = userDetails.userType;
      this.privilege = userDetails.privilege;
      if (userDetails.permissions) {
        this.originalPermissions = JSON.parse(
          JSON.stringify(userDetails.permissions)
        );
      }
      this.permissions = userDetails.permissions;
      this.brand = userDetails.brand;
      this.dealerGroup = userDetails.dealerGroup || [];
    }
    this.token = token;
    this.readOnly = false;
    this.history = history;
  }

  generateResourcePath() {
    return `nsc/${this.market}`;
  }

  generateNSCResourcePath() {
    return `nsc/${this.market}`;
  }

  addReadOnlyPermissions(permissions) {
    this.permissions.rolePermissions = Object.assign(
      {},
      permissions.rolePermissions,
      this.permissions.rolePermissions
    );
  }

  removeReadOnlyPermissions() {
    this.permissions.rolePermissions = this.originalPermissions.rolePermissions;
  }
}
